import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  Renderer2,
  ViewChild,
  WritableSignal,
  signal
} from '@angular/core';
import {ConnectedPosition, OverlayModule} from '@angular/cdk/overlay';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.html',
  styleUrl: './dropdown-menu.scss',
  imports: [OverlayModule]
})
export class DropdownMenu implements AfterViewInit {

  @Output()
  toggle = new EventEmitter<'OPEN' | 'CLOSE'>();

  @ViewChild('trigger', { read: ElementRef })
  trigger!: ElementRef<HTMLElement>;

  @ViewChild('content', { read: ElementRef })
  content!: ElementRef<HTMLElement>;

  isOpen: WritableSignal<boolean> = signal(false);

  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
    }
  ];

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {}

  handleBackdropClick(event: Event) {
    event.stopPropagation();
    this.isOpen.update(prev => !prev);
  }

  handleTriggerClick(event: Event) {
    event.stopPropagation();
    this.isOpen.update(prev => !prev);
  }

  handleContentClick() {
    this.isOpen.set(false);
  }
}